import DashClicks from './DashClicks';

export default DashClicks;
